import * as React from 'react';

import { cn } from '@/lib/utils';

/** Centered max-width wrapper with responsive gutters. */
export function Container({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('mx-auto w-full max-w-[1200px] px-6 lg:px-8', className)}
      {...props}
    />
  );
}
